import script from "./TwoFactorAuthenticationPin.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorAuthenticationPin.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorAuthenticationPin.vue?vue&type=style&index=0&id=6cbed6fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cbed6fe"]])

export default __exports__